// «Браузер агента» в настройках: в каких сайтах выполнен вход (по кукам) и кнопка удалённого экрана.
// Входит владелец сам — агент потом пользуется входом, но паролей не видит.
import { Button, Card, Chip } from '@autoaff/ui';
import { useQuery } from '@tanstack/react-query';
import { Link, useNavigate } from '@tanstack/react-router';
import { MonitorSmartphone } from 'lucide-react';
import { api } from '../api';
import './browser.css';

export interface BrowserSiteView {
  id: string;
  name: string;
  loggedIn: boolean | null;
  cookies: number;
}
export interface BrowserState {
  configured: boolean;
  online: boolean;
  version: string | null;
  sites: BrowserSiteView[];
  error: string | null;
}

export function useBrowser(poll = false) {
  return useQuery({
    queryKey: ['browser'],
    queryFn: () => api<BrowserState>('/api/browser'),
    refetchInterval: poll ? 5_000 : 60_000,
  });
}

export function SiteChip({ s }: { s: BrowserSiteView }) {
  if (s.loggedIn === true)
    return (
      <Chip tone="success" dot>
        Вход выполнен
      </Chip>
    );
  if (s.loggedIn === false) return <Chip>Не выполнен</Chip>;
  return <Chip>{s.cookies ? 'Вход сохранён' : 'Не открывался'}</Chip>;
}

export function BrowserCard() {
  const q = useBrowser();
  const navigate = useNavigate();
  const d = q.data;
  const status = !d ? null : !d.configured ? (
    <Chip>Не запущен на этом сервере</Chip>
  ) : d.online ? (
    <Chip tone="success" dot>
      Работает
    </Chip>
  ) : (
    <Chip tone="warning" dot>
      Не отвечает
    </Chip>
  );
  return (
    <Card
      title="Браузер агента"
      action={
        <Button
          size="sm"
          variant="primary"
          icon={<MonitorSmartphone />}
          disabled={!d?.configured}
          onClick={() => void navigate({ to: '/settings/browser' })}
        >
          Открыть удалённый экран
        </Button>
      }
    >
      <div className="bw-intro">
        {status}
        <p>
          В этом браузере агент ищет футаж, а платформа скачивает видео. Войдите в запасные аккаунты — вход
          сохранится. Пароли вводите сами на удалённом экране: агент их не видит. Кабинет buyo здесь не
          открывайте.
        </p>
        {d?.error && d.configured && <p className="bw-error">{d.error}</p>}
      </div>
      <ul className="bw-sites">
        {(d?.sites ?? []).map((s) => (
          <li key={s.id}>
            <b>{s.name}</b>
            <SiteChip s={s} />
            <Link
              to="/settings/browser"
              search={{ site: s.id }}
              className="btn btn-sm btn-ghost"
              aria-disabled={!d?.configured}
            >
              {s.loggedIn ? 'Открыть' : 'Войти'}
            </Link>
          </li>
        ))}
      </ul>
    </Card>
  );
}
